import React, { useState, useMemo } from "react";

import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import ReplyIcon from '@mui/icons-material/Reply';
import { Box, TextField, Button } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import { useTheme } from "@mui/material/styles";


export default function Notification({ type }) {
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [replyPanel, setReplyPanel] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

   const theme = useTheme();

  const notifications = [
    { id: 1, name: "Yasitha Fernando", email: "yasitha@vtas.lk", date: "12/05/2025", readstatus: 1, replied: 0, message: "Your account settings were updated successfully." },
    { id: 2, name: "Kamal Perera", email: "kamal@vtas.lk", date: "13/05/2025", readstatus: 1, replied: 1, message: "Thank you for contacting us. We have replied to your inquiry." },
    { id: 3, name: "Nimal Silva", email: "nimal@vtas.lk", date: "14/05/2025", readstatus: 0, replied: 0, message: "You have received a new unread message." },
    { id: 4, name: "Sachini Jayasinghe", email: "sachini@vtas.lk", date: "15/05/2025", readstatus: 0, replied: 0, message: "Please review the attached document and provide your feedback." },
    { id: 5, name: "Dilan Wijesinghe", email: "dilan@vtas.lk", date: "16/05/2025", readstatus: 1, replied: 1, message: "Your issue has been successfully resolved." },
    { id: 6, name: "Anusha Perera", email: "anusha@vtas.lk", date: "17/05/2025", readstatus: 1, replied: 0, message: "Reminder: You have a pending task in your dashboard." },
    { id: 7, name: "Ruwan Fernando", email: "ruwan@vtas.lk", date: "18/05/2025", readstatus: 1, replied: 0, message: "We have received your message and will respond shortly." },
    { id: 8, name: "Isuru Bandara", email: "isuru@vtas.lk", date: "19/05/2025", readstatus: 1, replied: 1, message: "Your request has been processed successfully." },
    { id: 9, name: "Tharindu Gunasekara", email: "tharindu@vtas.lk", date: "20/05/2025", readstatus: 0, replied: 0, message: "New notification regarding your recent activity." },
    { id: 10, name: "Pavithra Senanayake", email: "pavithra@vtas.lk", date: "21/05/2025", readstatus: 0, replied: 1, message: "Please confirm your email address to continue.Please confirm your email address to continue.Please confirm your email address to continue.Please confirm your email address to continue." }
  ];

  const filteredNotifications = useMemo(() => {
    if (type === "unread") return notifications.filter(n => n.readstatus === 0);
    if (type === "replied") return notifications.filter(n => n.replied === 1);
    return notifications;
  }, [type]);

  const handleCheckboxChange = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const selectAllMessages = () =>{
    const allSelected = filteredNotifications.every(n => selectedIds.includes(n.id));

    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(filteredNotifications.map(n => n.id));
    }
  };

  return (
    <div style={{ height: "80vh", display: "flex" }}>
      <div style={{flex: 2, borderRight: "1px solid #ddd"}}>
        <div style={{ padding:"12px 16px", borderBottom: "1px solid #ddd", display: "flex", justifyContent: "space-between" }}>
          <div>
            <h4 style={{ fontWeight: "Bold", paddingBottom: 0, marginBottom: 0, color:"#0098f0ff" }}>
              {type.toUpperCase()}
            </h4>
            <p style={{ paddingBottom: 0, marginBottom: 0 }}>{filteredNotifications.length} Messages </p>
          </div>

          <div>
            {selectedIds.length > 0 && (
              <>
                <Tooltip title="Delete">
                  <IconButton
                    sx={{
                      // color: "rgba(0, 0, 0, 0.7)",
                      "&:hover": {
                        color: "red",
                        backgroundColor: "transparent",
                      },
                    }}
                  > <DeleteForeverIcon /></IconButton>
                </Tooltip>
                <Tooltip title="Mark Read">
                  <IconButton
                    sx={{
                      // color: "rgba(0, 0, 0, 0.7)",
                      "&:hover": {
                        color: "#0ea001ff",
                        backgroundColor: "transparent",
                      },
                    }}
                  > <MarkEmailReadIcon /></IconButton>
                </Tooltip>
              </>
            )}
            <Tooltip title="Select All">
              <IconButton
                sx={{
                  // color: "rgba(0, 0, 0, 0.7)",
                  "&:hover": {
                    color: "#2091e7ff",
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => selectAllMessages()}
              > <ChecklistRtlIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Refresh">
              <IconButton
                sx={{
                  // color: "rgba(0, 0, 0, 0.7)",
                  "&:hover": {
                    color: "#2091e7ff",
                    backgroundColor: "transparent",
                  },
                }}
              > <RefreshIcon /></IconButton>
            </Tooltip>
          </div>
        </div>

        
        {/* LIST */}
        <div style={{ height: "100%", overflowY: "auto" }}>
          {filteredNotifications.map(item => (
            <div
              key={item.id}
              onClick={() => setSelectedNotification(item)}
              style={{
                padding: 12,
                cursor: "pointer",
                background: selectedNotification?.id === item.id && "#177cacff",
                borderBottom: "1px solid #eee",
              }}
            >
              <Checkbox
                checked={selectedIds.includes(item.id)}
                onClick={e => e.stopPropagation()}
                onChange={() => handleCheckboxChange(item.id)}
              />
              <strong>{item.name}</strong> <span style={{fontSize:"12px"}}>{item.date}</span>
              <div style={{ fontSize: 14 }}>{item.message}</div>
            </div>
          ))}
        </div>
      </div>
      {/* VIEW */}
      <div style={{ flex: 3, padding:"20px" }}>
        {selectedNotification ? (
          <>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 0"}}>
              <Tooltip title="Reply">
                <IconButton
                  sx={{
                    // color: "rgba(0, 0, 0, 0.7)",
                    "&:hover": {
                      color: "#2091e7ff",
                      backgroundColor: "transparent",
                    },
                  }} onClick={() => setReplyPanel(true)}>
                  <ReplyIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  sx={{
                    // color: "rgba(0, 0, 0, 0.7)",
                    "&:hover": {
                      color: "red",
                      backgroundColor: "transparent",
                    },
                  }}><DeleteForeverIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Close">
                <IconButton
                  sx={{
                    // color: "rgba(0, 0, 0, 0.7)",
                    "&:hover": {
                      color: "grey",
                      backgroundColor: "transparent",
                    },
                  }} onClick={() => setSelectedNotification(null)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div>
              <h2>{selectedNotification.name}</h2>
              <h5>{selectedNotification.date}</h5>
              <p>{selectedNotification.message}</p>
            </div>
            {replyPanel && (
              <div>
                <Box
                  component="form"
                  sx={{
                    position: "relative",
                    border: "1px solid #000",
                    borderRadius: "8px",
                    p: 2
                  }}
                  noValidate
                  autoComplete="off"
                >

                  {/* Content */}
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "15px"}}>

                    {/* To Field */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ fontSize: "18px" }}> To : &nbsp; </div>
                      <TextField
                        hiddenLabel
                        defaultValue={selectedNotification.email}
                        variant="outlined"
                        size="small"

                      />
                    </div>

                    {/* Subject */}
                    <TextField
                      id="reply-subject"
                      label="Subject"
                      variant="outlined"
                      fullWidth
                    />

                    {/* Message */}
                    <TextField
                      id="reply-message"
                      label="Message"
                      variant="outlined"
                      multiline
                      rows={5}
                      fullWidth
                    />

                    <div style={{display:"flex", justifyContent:"center", gap:"10px"}}>
                      <Button variant="contained" onClick={() => setReplyPanel(false)}> Cancel </Button>
                      <Button variant="contained" endIcon={<SendIcon />}> Send </Button>
                    </div>
                  </Box>
                </Box>


              </div>
            )}
          </>
        ) : (
          <p style={{ textAlign: "center", marginTop: "30%", color: "#888" }}>
            Select a Message to View
          </p>
        )}
      </div>
        
      
    </div>
  );
}
